import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemGroup from '../FormItemGroup';
import FormItemUtil from '../../utils/FormItemUtil';
import CmdTypeActions from '../../actions/CmdTypeActions';
import {UpdateGroupCollapseStateStore} from '../../stores/CmdTypeStore';

export default class FormItemGroupControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemGroupControl";
		this.initExpand = true;
		if(this.getProperty_Collapsible())
		{
			this.unsubscribeUpdateGroupCollapseStateStore = UpdateGroupCollapseStateStore.listen(this.onUpdateGroupCollapseStateStore.bind(this));
		}
	}

	onUpdateGroupCollapseStateStore(arg)
	{
		if(arg && arg.hasOwnProperty(this.xml.name))
		{
			this.initExpand = arg[this.xml.name];
		}
	}

	getProperty_GroupType()
	{
		return this.properties.GroupType;
	}

	getProperty_ShowBorder()
	{
		return false;
		return this.properties.ShowBorder;
	}

	getProperty_ShowLabel()
	{
		return this.properties.ShowLabel;
	}

	getProperty_Collapsible()
	{
		return this.properties.Collapsible;
	}

	getProperty_MainContentAlignment()
	{
		return this.properties.MainContentAlignment;
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}

	getStyle()
	{
		let superStyle = super.getStyle();
		if(superStyle)
		{
			let justifyContent = this.getProperty_MainContentAlignment();
			if(!justifyContent)justifyContent = "flex-start";
			superStyle.justifyContent = justifyContent;
			//TODO 与Flex一致,Group加了默认padding
			superStyle.padding = '1px 2px';

			if(typeof(superStyle.width) == "string" && superStyle.width.indexOf("px") != -1)
			{
				superStyle.overflowX = "auto";
				if(!superStyle.overflowY)superStyle.overflowY = "hidden"
			}
			if(typeof(superStyle.height) == "string" && superStyle.height.indexOf("px") != -1)
			{
				superStyle.overflowY = "auto";
				if(!superStyle.overflowX)superStyle.overflowX = "hidden";
			}
		}
		
		return superStyle;
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let label = this.getProperty_Label();
		let showLabel = this.getProperty_ShowLabel();
		let commonProps = this.getCommonProps();
		let hasBorder = showLabel;
		let isGroupQuery = this.getProperty_GroupType() == "Query";
		if(this.hasBorderSetted)
		{
			if(this.propertyHasBorder)
			{
				/*superStyle.border="solid 1px #ccc";superStyle.margin = "1px";
				if(this.getProperty_GroupType() == "Query")superStyle.margin="2px";*/
				hasBorder = true;
			}
			/*else
			{
				superStyle.border = "none";
			}*/
				
		}
		else
		{
			if(isGroupQuery)
				/*{superStyle.border="solid 1px #ccc";superStyle.margin="2px";}*/
				hasBorder = true;
			else if(this.getProperty_ShowBorder())
				/*{superStyle.border = "solid 1px #ccc";superStyle.margin= "1px";}*/
				hasBorder = true;
			/*else
				{superStyle.border = "none";}*/
		}
		this.component = <FormItemGroup key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} control={this}  
                        parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} isGroupQuery={isGroupQuery}
                        label={label} hasBorder={hasBorder} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                        contextMenuData={this.contextMenuData} showLabel={showLabel} foldable={this.getProperty_Collapsible()} expand={this.initExpand} {...commonProps}/>;
		return this.component;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemGroupControl.js